export { WalletDetector } from './WalletDetector';
